export const apiUrl = import.meta.env.VITE_API_URL
export const MINIMUM_ITEM_COUNT = 75
export const FINAL_ITEM_INDEX = MINIMUM_ITEM_COUNT - 1

export const STORAGE_BUCKET_FOLDER_USER_IMAGES = 'user_images'
export const ENABLE_AI_COMPANION = import.meta.env.VITE_ENV !== 'production'
